// de strings for messages/hub.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const hub: Dict = {
  "hub.views.count": "Über 10 Milliarden",
  "hub.views.on": "Aufrufe auf",
  "hub.badge.covers": "Über 10 Mio. Cover erstellt",
  "hub.badge.quality": "Studioqualität",
  "hub.badge.youtube": "Bekannt von YouTube",
  "hub.trending": "Im Trend",
  "hub.popular": "Gerade beliebte Stimmen",
  "hub.browseAll": "Alle ansehen",
  "hub.byCategory": "Stimmen nach Kategorie",
  "hub.aiVoices": "KI-Stimmen",
  "hub.howItWorks": "So funktioniert's",
  "hub.faq": "Häufige Fragen",
  "hub.keepExploring": "Weiter entdecken",
  "hub.moreWays": "Noch mehr Möglichkeiten mit Jammable.",
  "hub.home": "Start",

  "widget.title": "Wähl eine Stimme zum Start",
  "widget.search": "Stimmen suchen",
  "widget.clear": "Suche löschen",
  "widget.matching": "Stimmen zu „{q}“",
  "widget.popular": "Gerade beliebt",
  "widget.noMatch": "Keine Stimme passt zu deiner Suche.",
  "widget.searchAny": "Such oben nach einer beliebigen Stimme.",
  "widget.coverWith": "Cover mit {name} erstellen",
  "widget.start": "Mit einer beliebigen Stimme starten",
  "widget.rights":
    "Danach fügst du dein Audio hinzu. Lade nur Audio hoch, für das du die Rechte hast.",

  "lang.viewThisPage": "Diese Seite auf Deutsch ansehen",
  "lang.dismiss": "Schließen",
};

export default hub;
